/**
 * Zager PDP: the two informational popups.
 *
 * The thumbnail → hero swap this file used to carry is gone (2026-10-13).
 * Live's hero and thumbnails are plain links to the photo gallery in a new
 * tab, so the thumbnails are `<a>`s in the section and there is no swap left
 * to script.
 */

/**
 * "See Total with Case and Shipping" / "Financing" popups.
 *
 * Native <dialog>, so focus trapping and Escape come from the platform. Bound
 * at document level because the buttons and their dialogs are siblings rather
 * than nested, and there is at most one PDP per page.
 */
document.addEventListener('click', (event) => {
  const target = event.target instanceof Element ? event.target : null;
  if (!target) return;

  const opener = target.closest('[data-zager-popup]');
  if (opener instanceof HTMLElement) {
    const name = opener.dataset.zagerPopup;
    const dialog = document.querySelector(`[data-zager-popup-body="${name}"]`);
    if (dialog instanceof HTMLDialogElement) dialog.showModal();
    return;
  }

  if (target.closest('[data-zager-popup-close]')) {
    target.closest('dialog')?.close();
  }
});

/**
 * Backdrop click closes dialogs marked data-zager-popup-backdrop (the sold-out
 * "Notify me" form). A click whose target is the <dialog> itself landed on the
 * backdrop or its padding, so check the pointer against the dialog's box.
 */
document.addEventListener('click', (event) => {
  const dialog = event.target;
  if (!(dialog instanceof HTMLDialogElement) || !dialog.hasAttribute('data-zager-popup-backdrop')) return;
  const rect = dialog.getBoundingClientRect();
  const inside =
    event.clientX >= rect.left &&
    event.clientX <= rect.right &&
    event.clientY >= rect.top &&
    event.clientY <= rect.bottom;
  if (!inside) dialog.close();
});

/**
 * Sold-out "Notify me": fill Klaviyo's hidden "Page URL" field.
 *
 * Port of WP functions.php:3485 (klaviyo_form_page_url_field_hide_func). The
 * Tuhewv form carries an input whose id starts "Page_Url_"; WP writes the
 * current page URL into it and hides its row, so each signup says which guitar
 * it was for. Klaviyo renders the form asynchronously and may re-render it, so
 * while the notify dialog is open we re-apply every 500 ms (WP polls every
 * second, forever). The input event lets Klaviyo's own form state see the value.
 */
const notifyDialog = document.querySelector('[data-zager-popup-body="notify"]');
if (notifyDialog instanceof HTMLDialogElement) {
  let timer = 0;

  const fillPageUrl = () => {
    const field = notifyDialog.querySelector('input[id^="Page_Url_"]');
    if (!(field instanceof HTMLInputElement)) return;
    if (field.value !== window.location.href) {
      const setValue = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value')?.set;
      if (setValue) setValue.call(field, window.location.href);
      else field.value = window.location.href;
      field.dispatchEvent(new Event('input', { bubbles: true }));
    }
    const row = field.closest('[data-testid="form-row"]');
    if (row instanceof HTMLElement) row.style.setProperty('display', 'none', 'important');
  };

  new MutationObserver(() => {
    if (notifyDialog.open && !timer) {
      fillPageUrl();
      timer = window.setInterval(fillPageUrl, 500);
    } else if (!notifyDialog.open && timer) {
      window.clearInterval(timer);
      timer = 0;
    }
  }).observe(notifyDialog, { attributes: true, attributeFilter: ['open'] });
}
